/**
 * Frases de la carta.
 *
 * ⚠️ PLACEHOLDER: 10 frases poéticas para desarrollo visual.
 * Reemplazar con contenido real en Chunk 10 (entrega del usuario).
 *
 * Ver docs/SPEC.md §5.2 y docs/TASKS.md T6.2, T10.1.
 */

export const FRASES_PLACEHOLDER: readonly string[] = [
  'Hay una noche de septiembre que vuelve cada año, como vuelven las luciérnagas al jardín.',
  'Esta es esa noche.',
  'Cuando el cielo se vuelve indigo, mi pensamiento busca el tuyo como las flores buscan el sol.',
  'Cada pétalo de girasol me recuerda algo tuyo: la forma en que miras, la forma en que sonríes.',
  'Las luciérnagas titilan al ritmo que me late el corazón cuando te veo.',
  'Y no hay audio que se compare con tu risa, pero esta canción se le parece un poco.',
  'Septiembre es el mes en que aprendí que las cosas importantes no se apuran: se cultivan.',
  'Como esta carta. Como nosotros.',
  'Como cada primavera que vuelve y nos encuentra juntos, un año más.',
  'Te quiero. Y esta noche quise demostrártelo a mi manera.',
] as const;
